import React from 'react';
import PropTypes from 'prop-types';
import { Divider, DividerWrapper } from './HorizontalDivider.css';

const HorizontalDivider = props => {
  const { maxWidth, padding } = props;
  return (
    <DividerWrapper maxWidth={maxWidth} padding={padding}>
      <Divider />
    </DividerWrapper>
  );
};

HorizontalDivider.propTypes = {
  maxWidth: PropTypes.string,
  padding: PropTypes.string
};

export default HorizontalDivider;
